import { AxiosRequestConfig } from 'axios';

import { config } from './config';
import request from './request';

async function cacheAdapter(req: AxiosRequestConfig) {
  const res = await request(req, config);
  return res;
}

export default cacheAdapter;
